exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "iframe#mountable[data-v-3ca789b4] {\n  display: block;\n  margin: 0 auto;\n  width: 95%;\n  height: 150vh;\n  overflow: visible;\n}\n.justify-evenly[data-v-3ca789b4] {\n  -webkit-justify-content: space-evenly;\n      -ms-flex-pack: space-evenly;\n          justify-content: space-evenly;\n}\n", ""]);

// exports
